// userSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { PortalUsersService } from '../../services/PortalUsersService';

// Async thunk for fetching all available user roles
export const fetchUserRoles = createAsyncThunk(
  'users/fetchUserRoles',
  async (_, { rejectWithValue }) => {
    try {
      const response = await PortalUsersService.get_user_roles();
      return response.data; 
    } catch (error) {
      return rejectWithValue('Failed to fetch user roles');
    }
  }
);

const userSlice = createSlice({
  name: 'users',
  initialState: {
    roles: [],
    assignedRoles: [], // Store user's assigned roles here
    loadingRoles: false,
    loadingPermissions: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch all roles
      .addCase(fetchUserRoles.pending, (state) => {
        state.loadingRoles = true;
        state.error = null;
      })
      .addCase(fetchUserRoles.fulfilled, (state, action) => {
        state.roles = action.payload;
        state.loadingRoles = false;
      })
      .addCase(fetchUserRoles.rejected, (state, action) => {
        state.error = action.payload;
        state.loadingRoles = false;
      })
  },
});

export default userSlice.reducer;